
import { combineReducers } from 'redux';
import finances from './finances';
import auth from './auth';
import schedule from './schedule';
import profile from './profile';
import register from './register';
import code from './code';
import reset from './reset';
import general from './general';
import reviews from './reviews';
import programs from './programs';
import homework from './homework';
import attempts from './attempts';
import notification from './notification';
import test from './test';

const rootReducer = combineReducers({
  auth,
  schedule,
  finances,
  profile,
  register,
  code,
  reset,
  general,
  reviews,
  programs,
  homework,
  attempts,
  notification,
  test
});

export default rootReducer;
